<div class="d-flex flex-column h-100">
  <ca-top-nav [flexibleTopNav]="flexibleMobileNav">
    <ng-content select="[caTopNavSearch]"></ng-content>
  </ca-top-nav>

  <div class="ca-drawer-container">
    @if (!(shouldHideSideNav$ | async)) {
    <ca-side-nav
      [navigationMap]="sideNavigationMap$ | async"
      [flexibleSideNav]="flexibleMobileNav"
      [appNameLocation]="(appNameLocation$ | async)!"
    ></ca-side-nav>
    }
    <ng-container #mobileDrawerContainer>
      <div
        class="ca-content-wrapper"
        [class.overflow-hidden]="!changedScrollEnabled()"
        [class.ca-content-nav-expanded]="(sideNavExpanded$ | async) && !mobile && (isImpersonating$ | async)"
        [class.ca-content-nav-collapsed]="!(sideNavExpanded$ | async) && !mobile && (isImpersonating$ | async)"
        #updatedScrollableElement
      >
        <ng-container #desktopDrawerContainer>
          @if (!(shouldHideSideNav$ | async)) {
          <ca-breadcrumbs></ca-breadcrumbs>
          }
          <div class="ca-content mt-n1 pt-1" [class.overflow-auto]="!changedScrollEnabled()" #scrollableElement>
            <ng-content></ng-content>
          </div>
          @if (isImpersonating$ | async) {
          <ca-impersonation-banner></ca-impersonation-banner>
          } @if (shouldShowCookieBanner$ | async) {
          <ca-footer></ca-footer>
          }
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
